import { render, staticRenderFns } from "./PlaceOfWork.vue?vue&type=template&id=e90a542c&"
import script from "./PlaceOfWork.vue?vue&type=script&lang=js&"
export * from "./PlaceOfWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports